<template>
  <div class="loglist">
    <div class="loglist-item" v-for="item in list" :key="item.tskLogCode">
      <div class="loglist-mem" :class="{ 'bt-none': !item.showMem }">
        <el-avatar
          :src="item.logByMemImgUrl"
          shape="square"
          :size="50"
          v-if="item.showMem"
        >
          U
        </el-avatar>
        <div style="width: 50px" v-else></div>
      </div>
      <div class="loglist-content">
        <div class="loglist-content-title" v-html="item.logTitle || ''"></div>
        <div
          class="loglist-content-body mt-1 d-flex"
          v-if="item.logContent && item.logType == 'D'"
        >
          <div v-for="(t, i) in item.logContent" :key="i" class="p-2 doc-item">
            <div class="d-flex justify-content-center">
              <el-avatar
                shape="square"
                :size="60"
                :src="t.fileIcon"
                class="bg-transparent"
              />
            </div>
            <a
              class="mt-3 flex-grow-1 text-truncate"
              style="cursor: pointer"
              @click="download(t)"
            >
              {{ t.fileName }}
            </a>
          </div>
        </div>
        <div
          class="loglist-content-remark"
          v-if="item.logContent && item.logType == 'R'"
        >
          {{ item.remark }}
        </div>
        <div class="loglist-content-time mt-2">{{ item.logTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
import { request } from '@/api/service'
export default {
  props: { tskInfoCode: { type: String, default: '' } },
  data() {
    return { list: [], fileIcons: {} }
  },
  async mounted() {
    await this.getFileIcons()
    this.getData()
  },
  methods: {
    async getFileIcons() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    getFileIcon(fileName) {
      const getFileType = (filename) => {
        if (!filename) return ''
        if (!filename.includes('.')) return ''
        return filename.split('.').pop()
      }

      const fileType = getFileType(fileName) || 'OTHER'
      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },
    async getData() {
      const res = await this.$api
        .personalTskLogListApi({ tskInfoCode: this.tskInfoCode })
        .catch(() => null)
      this.list = []
      const data = res?.body?.data || []
      if (!data?.length) return

      let logBy = data[0].logBy
      for (const index in data) {
        const item = data[index]
        item.showMem = true
        if (index == 0) continue

        item.showMem = logBy !== item.logBy
        if (item.showMem) logBy = item.logBy
      }

      this.list = data.map((item) => {
        let { logTime, logType, logContent } = item
        let remark = ''
        const t = {
          ...item,
          logTime: dayjs(logTime).locale('zh-cn').fromNow(),
        }

        if (logContent && logType == 'D') {
          logContent = JSON.parse(logContent)
          logContent = logContent.map((c) => ({
            ...c,
            fileIcon: this.getFileIcon(c.fileName),
          }))
        }
        if (logContent && logType == 'R') {
          logContent = JSON.parse(logContent)
          remark = logContent.remarkText || ''
        }

        return { ...t, logContent, remark }
      })
    },
    download({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  strong {
    color: #0052cc;
  }
}
.loglist {
  .loglist-item {
    padding: 0 5px;
    display: flex;
    flex-direction: row;
    .loglist-mem {
      display: flex;
      padding-right: 10px;
      padding-top: 0.8rem;
      padding-bottom: 0.8rem;
      border-top: 1px solid #eaeaea;
    }
    .loglist-mem.bt-none {
      border-top: none;
    }
    .loglist-content {
      flex-grow: 1;
      font-size: 13px;
      color: #666;
      padding-top: 0.8rem;
      padding-bottom: 0.8rem;
      border-top: 1px solid #eaeaea;
      .loglist-content-title {
        line-height: 1.6;
      }
      .doc-item {
        width: 100px;
        border: 1px solid #e9e9e9;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        font-size: 12px;
        text-align: center;
      }
    }
  }
  .loglist-item:first-child {
    .loglist-mem,
    .loglist-content {
      border-top: none;
    }
  }
  .loglist-content-remark {
    font-weight: 500 !important;
    font-size: 12px;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
